module.exports = __webpack_public_path__ + "assets/img/LTC008.99880c83.png";